(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cw-collection-slider')) {
    customElements.define('cw-collection-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('.cw-home__slide')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.controls = this.querySelector('.cw-home__slider-controls');
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.slides.length < 2) return;
        this.controls.hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1), {signal});
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), {signal});
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, {signal});
        this.addEventListener('focusin', () => this.stop(), {signal});
        this.addEventListener('focusout', () => setTimeout(() => { if (this.isConnected) this.schedule(); }, 0), {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.updatePause();
        this.schedule();
      }
      updatePause() {
        this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      }
      stop() { clearTimeout(this.timer); }
      schedule() {
        this.stop();
        if (!this.paused && !document.hidden && !this.contains(document.activeElement)) {
          this.timer = setTimeout(() => this.go(this.index + 1), 7000);
        }
      }
      go(next) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          slide.hidden = index !== this.index;
          slide.inert = index !== this.index;
        });
        this.querySelector('[data-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
        this.schedule();
      }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
